import _defineProperty from "/builds/elproag/cloud/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import { resetComponent } from '../../style';
import { genComponentStyleHook, mergeToken } from '../../theme/internal';
var genBorderedStyle = function genBorderedStyle(token) {
  var _$concat, _ref;
  var listBorderedCls = token.listBorderedCls,
    componentCls = token.componentCls,
    paddingLG = token.paddingLG,
    margin = token.margin,
    itemPaddingSM = token.itemPaddingSM,
    itemPaddingLG = token.itemPaddingLG,
    marginLG = token.marginLG,
    borderRadiusLG = token.borderRadiusLG;
  return _ref = {}, _defineProperty(_ref, "".concat(listBorderedCls), (_$concat = {
    border: "".concat(token.lineWidth, "px ").concat(token.lineType, " ").concat(token.colorBorder),
    borderRadius: borderRadiusLG
  }, _defineProperty(_$concat, "".concat(componentCls, "-header,").concat(componentCls, "-footer,").concat(componentCls, "-item"), {
    paddingInline: paddingLG
  }), _defineProperty(_$concat, "".concat(componentCls, "-pagination"), {
    margin: "".concat(margin, "px ").concat(marginLG, "px")
  }), _$concat)), _defineProperty(_ref, "".concat(listBorderedCls).concat(componentCls, "-sm"), _defineProperty({}, "".concat(componentCls, "-item,").concat(componentCls, "-header,").concat(componentCls, "-footer"), {
    padding: itemPaddingSM
  })), _defineProperty(_ref, "".concat(listBorderedCls).concat(componentCls, "-lg"), _defineProperty({}, "".concat(componentCls, "-item,").concat(componentCls, "-header,").concat(componentCls, "-footer"), {
    padding: itemPaddingLG
  })), _ref;
};
var genResponsiveStyle = function genResponsiveStyle(token) {
  var _mediaScreenAndM, _$concat8, _mediaScreenAndM2, _ref2;
  var componentCls = token.componentCls,
    screenSM = token.screenSM,
    screenMD = token.screenMD,
    marginLG = token.marginLG,
    marginSM = token.marginSM,
    margin = token.margin;
  return _ref2 = {}, _defineProperty(_ref2, "@media screen and (max-width:".concat(screenMD, ")"), (_mediaScreenAndM = {}, _defineProperty(_mediaScreenAndM, "".concat(componentCls), _defineProperty({}, "".concat(componentCls, "-item"), _defineProperty({}, "".concat(componentCls, "-item-action"), {
    marginInlineStart: marginLG
  }))), _defineProperty(_mediaScreenAndM, "".concat(componentCls, "-vertical"), _defineProperty({}, "".concat(componentCls, "-item"), _defineProperty({}, "".concat(componentCls, "-item-extra"), {
    marginInlineStart: marginLG
  }))), _mediaScreenAndM)), _defineProperty(_ref2, "@media screen and (max-width: ".concat(screenSM, ")"), (_mediaScreenAndM2 = {}, _defineProperty(_mediaScreenAndM2, "".concat(componentCls), _defineProperty({}, "".concat(componentCls, "-item"), _defineProperty({
    flexWrap: 'wrap'
  }, "".concat(componentCls, "-action"), {
    marginInlineStart: marginSM
  }))), _defineProperty(_mediaScreenAndM2, "".concat(componentCls, "-vertical"), _defineProperty({}, "".concat(componentCls, "-item"), (_$concat8 = {
    flexWrap: 'wrap-reverse'
  }, _defineProperty(_$concat8, "".concat(componentCls, "-item-main"), {
    minWidth: token.contentWidth
  }), _defineProperty(_$concat8, "".concat(componentCls, "-item-extra"), {
    margin: "auto auto ".concat(margin, "px")
  }), _$concat8))), _mediaScreenAndM2)), _ref2;
};
// =============================== Base ===============================
var genBaseStyle = function genBaseStyle(token) {
  var _$concat10, _$concat11, _$concat12, _Object$assign2, _$concat$concat3, _ref3;
  var componentCls = token.componentCls,
    antCls = token.antCls,
    controlHeight = token.controlHeight,
    minHeight = token.minHeight,
    paddingSM = token.paddingSM,
    marginLG = token.marginLG,
    padding = token.padding,
    itemPadding = token.itemPadding,
    colorPrimary = token.colorPrimary,
    itemPaddingSM = token.itemPaddingSM,
    itemPaddingLG = token.itemPaddingLG,
    paddingXS = token.paddingXS,
    margin = token.margin,
    colorText = token.colorText,
    colorTextDescription = token.colorTextDescription,
    motionDurationSlow = token.motionDurationSlow,
    lineWidth = token.lineWidth,
    headerBg = token.headerBg,
    footerBg = token.footerBg,
    emptyTextPadding = token.emptyTextPadding,
    metaMarginBottom = token.metaMarginBottom,
    avatarMarginRight = token.avatarMarginRight,
    titleMarginBottom = token.titleMarginBottom,
    descriptionFontSize = token.descriptionFontSize;
  var alignCls = {};
  ['start', 'center', 'end'].forEach(function (item) {
    alignCls["&-align-".concat(item)] = {
      textAlign: item
    };
  });
  return _ref3 = {}, _defineProperty(_ref3, "".concat(componentCls), Object.assign(Object.assign({}, resetComponent(token)), (_Object$assign2 = {
    position: 'relative',
    '*': {
      outline: 'none'
    }
  }, _defineProperty(_Object$assign2, "".concat(componentCls, "-header"), {
    background: headerBg
  }), _defineProperty(_Object$assign2, "".concat(componentCls, "-footer"), {
    background: footerBg
  }), _defineProperty(_Object$assign2, "".concat(componentCls, "-header, ").concat(componentCls, "-footer"), {
    paddingBlock: paddingSM
  }), _defineProperty(_Object$assign2, "".concat(componentCls, "-pagination"), Object.assign(Object.assign({
    marginBlockStart: marginLG
  }, alignCls), _defineProperty({}, "".concat(antCls, "-pagination-options"), {
    textAlign: 'start'
  }))), _defineProperty(_Object$assign2, "".concat(componentCls, "-spin"), {
    minHeight: minHeight,
    textAlign: 'center'
  }), _defineProperty(_Object$assign2, "".concat(componentCls, "-items"), {
    margin: 0,
    padding: 0,
    listStyle: 'none'
  }), _defineProperty(_Object$assign2, "".concat(componentCls, "-item"), (_$concat12 = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: itemPadding,
    color: colorText
  }, _defineProperty(_$concat12, "".concat(componentCls, "-item-meta"), (_$concat10 = {
    display: 'flex',
    flex: 1,
    alignItems: 'flex-start',
    maxWidth: '100%'
  }, _defineProperty(_$concat10, "".concat(componentCls, "-item-meta-avatar"), {
    marginInlineEnd: avatarMarginRight
  }), _defineProperty(_$concat10, "".concat(componentCls, "-item-meta-content"), {
    flex: '1 0',
    width: 0,
    color: colorText
  }), _defineProperty(_$concat10, "".concat(componentCls, "-item-meta-title"), {
    margin: "0 0 ".concat(token.marginXXS, "px 0"),
    color: colorText,
    fontSize: token.fontSize,
    lineHeight: token.lineHeight,
    '> a': _defineProperty({
      color: colorText,
      transition: "all ".concat(motionDurationSlow)
    }, "&:hover", {
      color: colorPrimary
    })
  }), _defineProperty(_$concat10, "".concat(componentCls, "-item-meta-description"), {
    color: colorTextDescription,
    fontSize: descriptionFontSize,
    lineHeight: token.lineHeight
  }), _$concat10)), _defineProperty(_$concat12, "".concat(componentCls, "-item-action"), (_$concat11 = {
    flex: '0 0 auto',
    marginInlineStart: token.marginXXL,
    padding: 0,
    fontSize: 0,
    listStyle: 'none'
  }, _defineProperty(_$concat11, "& > li", _defineProperty({
    position: 'relative',
    display: 'inline-block',
    padding: "0 ".concat(paddingXS, "px"),
    color: colorTextDescription,
    fontSize: token.fontSize,
    lineHeight: token.lineHeight,
    textAlign: 'center'
  }, "&:first-child", {
    paddingInlineStart: 0
  })), _defineProperty(_$concat11, "".concat(componentCls, "-item-action-split"), {
    position: 'absolute',
    insetBlockStart: '50%',
    insetInlineEnd: 0,
    width: lineWidth,
    height: Math.ceil(token.fontSize * token.lineHeight) - token.marginXXS * 2,
    transform: 'translateY(-50%)',
    backgroundColor: token.colorSplit
  }), _$concat11)), _$concat12)), _defineProperty(_Object$assign2, "".concat(componentCls, "-empty"), {
    padding: "".concat(padding, "px 0"),
    color: colorTextDescription,
    fontSize: token.fontSizeSM,
    textAlign: 'center'
  }), _defineProperty(_Object$assign2, "".concat(componentCls, "-empty-text"), {
    padding: emptyTextPadding,
    color: token.colorTextDisabled,
    fontSize: token.fontSize,
    textAlign: 'center'
  }), _defineProperty(_Object$assign2, "".concat(componentCls, "-item-no-flex"), {
    display: 'block'
  }), _Object$assign2))), _defineProperty(_ref3, "".concat(componentCls, "-grid ").concat(antCls, "-col > ").concat(componentCls, "-item"), {
    display: 'block',
    maxWidth: '100%',
    marginBlockEnd: margin,
    paddingBlock: 0,
    borderBlockEnd: 'none'
  }), _defineProperty(_ref3, "".concat(componentCls, "-vertical ").concat(componentCls, "-item"), (_$concat$concat3 = {
    alignItems: 'initial'
  }, _defineProperty(_$concat$concat3, "".concat(componentCls, "-item-main"), {
    display: 'block',
    flex: 1
  }), _defineProperty(_$concat$concat3, "".concat(componentCls, "-item-extra"), {
    marginInlineStart: marginLG
  }), _defineProperty(_$concat$concat3, "".concat(componentCls, "-item-meta"), _defineProperty({
    marginBlockEnd: metaMarginBottom
  }, "".concat(componentCls, "-item-meta-title"), {
    marginBlockStart: 0,
    marginBlockEnd: titleMarginBottom,
    color: colorText,
    fontSize: token.fontSizeLG,
    lineHeight: token.lineHeightLG
  })), _defineProperty(_$concat$concat3, "".concat(componentCls, "-item-action"), {
    marginBlockStart: padding,
    marginInlineStart: 'auto',
    '> li': _defineProperty({
      padding: "0 ".concat(padding, "px")
    }, "&:first-child", {
      paddingInlineStart: 0
    })
  }), _$concat$concat3)), _defineProperty(_ref3, "".concat(componentCls, "-split ").concat(componentCls, "-item"), _defineProperty({
    borderBlockEnd: "".concat(token.lineWidth, "px ").concat(token.lineType, " ").concat(token.colorSplit)
  }, "&:last-child", {
    borderBlockEnd: 'none'
  })), _defineProperty(_ref3, "".concat(componentCls, "-split ").concat(componentCls, "-header"), {
    borderBlockEnd: "".concat(token.lineWidth, "px ").concat(token.lineType, " ").concat(token.colorSplit)
  }), _defineProperty(_ref3, "".concat(componentCls, "-split").concat(componentCls, "-empty ").concat(componentCls, "-footer"), {
    borderTop: "".concat(token.lineWidth, "px ").concat(token.lineType, " ").concat(token.colorSplit)
  }), _defineProperty(_ref3, "".concat(componentCls, "-loading ").concat(componentCls, "-spin-nested-loading"), {
    minHeight: controlHeight
  }), _defineProperty(_ref3, "".concat(componentCls, "-split").concat(componentCls, "-something-after-last-item ").concat(antCls, "-spin-container > ").concat(componentCls, "-items > ").concat(componentCls, "-item:last-child"), {
    borderBlockEnd: "".concat(token.lineWidth, "px ").concat(token.lineType, " ").concat(token.colorSplit)
  }), _defineProperty(_ref3, "".concat(componentCls, "-lg ").concat(componentCls, "-item"), {
    padding: itemPaddingLG
  }), _defineProperty(_ref3, "".concat(componentCls, "-sm ").concat(componentCls, "-item"), {
    padding: itemPaddingSM
  }), _defineProperty(_ref3, "".concat(componentCls, ":not(").concat(componentCls, "-vertical)"), _defineProperty({}, "".concat(componentCls, "-item-no-flex"), _defineProperty({}, "".concat(componentCls, "-item-action"), {
    float: 'right'
  }))), _ref3;
};
// ============================== Export ==============================
export default genComponentStyleHook('List', function (token) {
  var listToken = mergeToken(token, {
    listBorderedCls: "".concat(token.componentCls, "-bordered"),
    minHeight: token.controlHeightLG
  });
  return [genBaseStyle(listToken), genBorderedStyle(listToken), genResponsiveStyle(listToken)];
}, function (token) {
  return {
    contentWidth: 220,
    itemPadding: "".concat(token.paddingContentVertical, "px 0"),
    itemPaddingSM: "".concat(token.paddingContentVerticalSM, "px ").concat(token.paddingContentHorizontal, "px"),
    itemPaddingLG: "".concat(token.paddingContentVerticalLG, "px ").concat(token.paddingContentHorizontalLG, "px"),
    headerBg: 'transparent',
    footerBg: 'transparent',
    emptyTextPadding: token.padding,
    metaMarginBottom: token.padding,
    avatarMarginRight: token.padding,
    titleMarginBottom: token.paddingSM,
    descriptionFontSize: token.fontSize
  };
});